(function($) {
	'use strict';
	$.fn.Collection__Print = function() {
		this.each(function() { 
			
			/*
			 * Action: Print Collection
			 */
			var $self = $(this);
			$self.off( $.Globals.clickEvent ).on( $.Globals.clickEvent, function(e) {
				e.preventDefault();
				
				// vars
				var print_dialog = $('#collection--print').html(),
					data = $self.data('json');
				
				// Now use mustache to render out overlay with correct URLs
				Mustache.parse( print_dialog );
				var output = Mustache.render( print_dialog, data );
				
				// Close other overlays
				var timeout = 10;
				if( $('#overlay-white .close-overlay').length > 0 ) {
					timeout = $.Globals.fxSpeed;
					$('#overlay-white .close-overlay').trigger('click');
				}
				
				// Wait for overlay to be closed
				setTimeout( function( ) {
					
					// Add to dom
					$.Body.append( output );
				
					// Async
					setTimeout( function() {
						
						// Fade it in
						$.Body.addClass('overlay-white-on');
						
						// Listen for clicks
						$('#overlay-white a').not('.close-overlay').off( $.Globals.clickEvent ).one( $.Globals.clickEvent, function(e) {
							e.preventDefault();
					
							// Open in a new window
							var print_window = window.open( $(this).attr('href'),'title', 'width=800, height=700' );

							if( print_window !== null ) {

								// Track in Google
								$.Globals.track_event( 'Collection Printed' );
						
								if( $(this).hasClass( 'print-presentation' ) ) {

									// Track in Google
									$.Globals.track_event( 'Collection Presentation Printed' );
								
								} else if( $(this).hasClass( 'print-notes' ) ){
							
									// Track in Google
									$.Globals.track_event( 'Collection Notes Printed' );
							
								}
						
								// Remove overlay
								$.Globals.closeOverlay();

							}else{

								alert( Front.translations.please_enable_popups );

							}
						});
						
						// Add global close overlay listener
						$.Globals.listenForGlobalCloseOverlay();
						
					}, 10 );

				}, timeout );
				
			});
			
		
		});
		return this;
	};
}(jQuery));